var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M10.8 0H1.6C0.7 0 0 0.7 0 1.6V20.4C0 21.2 0.7 22 1.6 22H10.8C11.7 22 12.4 21.3 12.4 20.4V1.6C12.4 0.7 11.7 0 10.8 0ZM3.9 1H8.5C8.6 1 8.7 1.2 8.7 1.4C8.7 1.6 8.6 1.8 8.5 1.8H3.9C3.8 1.8 3.7 1.6 3.7 1.4C3.7 1.1 3.8 1 3.9 1ZM6.2 20.4C5.6 20.4 5.2 19.9 5.2 19.4C5.2 18.8 5.7 18.4 6.2 18.4C6.8 18.4 7.2 18.9 7.2 19.4C7.2 19.9 6.8 20.4 6.2 20.4ZM11.2 16.9H1.2V2.7H11.2V16.9Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"12.4","height":"22","fill":"white"})))]);
}

PhoneInline.defaultProps = {"width":"13","height":"22","viewBox":"0 0 13 22","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
